<div class="offer-review-card-wrapper">
  <div class="offer-review-details">
    <div>
      <p><b>Name</b></p>
      <p>{{ getOfferName$() | async }}</p>
    </div>
    <div>
      <p><b>Discount</b></p>
      <p>{{ getOfferDiscount$() | async }}</p>
    </div>
  </div>
  <p-divider></p-divider>
  <div class="offer-review-details">
    <div>
      <p><b>Duration</b></p>
      <p>{{ getOfferStartDate$() | async }} - {{ getOfferEndDate$() | async }}</p>
    </div>
  </div>
  <p-divider></p-divider>
  <div class="offer-review-details">
    <div>
      <p><b>Scheduled Reminder</b></p>
      <p>{{ getOfferReminderDate$() | async }}</p>
    </div>
    <div>
      <p><b>Message</b></p>
      <p>{{ getOfferSMSMessage$() | async }}</p>
    </div>
  </div>
  <ng-container *ngIf="audienceFilterLabel">
    <p-divider></p-divider>
    <div class="offer-review-details">
      <div>
        <p><b>Target Audience</b></p>
        <p>{{ audienceFilterLabel }}</p>
      </div>
      <div>
        <p><b>List Type</b></p>
        <p>{{ audienceListTypeLabel }}</p>
      </div>
      <div>
        <p><b>Estimated Recipients</b></p>
        <p>{{ (previewCount$ | async) ?? 'N/A' }}</p>
      </div>
    </div>
  </ng-container>
</div>
